import styled from "styled-components";
import { Select } from "antd";
import ReactSVG from "react-svg";

export const inBtwPadding = "18px";
export const elHeight = "24px";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 600px;
  color: ${({ theme }) => theme.editor.textLight};

  hr.form-divider {
    border: 1px solid ${({ theme }) => theme.editor.backgroundLight};
  }

  input {
    font-family: ${({ theme }) => theme.fontHeavy} !important;
  }

  .input-error {
    color: red;
    font-size: 12px;
    font-family: ${({ theme }) => theme.fontMedium};
    margin-bottom: 8px;
  }

  input.variation-title {
    font-size: 16px !important;
    font-family: ${({ theme }) => theme.fontHeavy} !important;
  }

  .title {
    font-size: 20px;
    padding-bottom: 10px;
  }

  .trackinfo-title {
    white-space: nowrap;
    align-self: flex-start;
    margin-top: 4px;
  }

  .variation-title-container {
    flex: 1;
  }

  .inputs {
    margin-top: 16px;

    .track-attribute {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 16px;
      gap: 18px;

      label {
        display: inline-block;
        font-family: ${({ theme }) => theme.fontHeavy};
        color: ${({ theme }) => theme.editor.textLight};
        font-size: 14px;
        width: 40%;
        text-align: right;
      }

      .track-attribute-data {
        display: flex;
        align-items: center;
        font-family: ${({ theme }) => theme.fontMedium};
        color: ${({ theme }) => theme.editor.textMedium};
        font-size: 14px;
      }

      input {
        width: 80px;
        height: ${elHeight};
        font-family: ${({ theme }) => theme.fontHeavy};
      }
    }
  }

  .trackinfo-label {
    color: ${({ theme }) => theme.editor.textLight};
    font-size: 12px;
  }

  .trackinfo-data {
    color: ${({ theme }) => theme.editor.textMedium};
    font-size: 14px;
  }

  .caption {
    font-size: 12px;
    font-family: ${({ theme }) => theme.fontLight};
    color: ${({ theme }) => theme.editor.textMedium};
  }

  .header {
    font-family: ${({ theme }) => theme.fontHeavy};
    color: ${({ theme }) => theme.editor.textLight};
    font-size: 14px;
    text-align: left;
    margin-bottom: 12px;
  }

  .variation-tools {
    max-height: 200px;
    overflow-y: auto;
    color: ${({ theme }) => theme.editor.textMedium};
    margin-top: 8px;
  }

  .variation-legal-agreement {
    max-height: 200px;
    margin-top: 8px;
    overflow-y: auto;
    font-size: 12px;
    font-family: ${({ theme }) => theme.fontLight};
    color: ${({ theme }) => theme.editor.textMedium};

    ::-webkit-scrollbar {
      width: 8px;
      opacity: 0;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      opacity: 0;
      width: 15px;
      background-color: ${props => props.theme.backgroundDark};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.06);
      opacity: 0.6;
      border-radius: 2px;
    }
  }

  .ant-tooltip-content {
    width: 325px;
  }

  .i-icon {
    height: 12px;
    margin-right: 8px;
  }

  #signature-container {
    display: flex;
    flex-flow: column nowrap;
    gap: 8px;
  }

  #full-name-container {
    display: flex;
    flex-flow: column nowrap;
    gap: 4px;
  }

  #signature-canvas-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  #signature-clear {
    border-radius: ${props => props.theme.br.lg};
    background-color: ${props => props.theme.backgroundTag};
    color: ${props => props.theme.textLight};
    cursor: pointer;
    padding: 0 14px;
  }

  .sign-label {
    color: ${({ theme }) => theme.editor.textLight};
    font-size: 14px;
  }

  @keyframes bounce {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
    100% {
      transform: translateY(0);
    }
  }

  .pulsing-i-icon {
    height: 8px;
    margin-left: 3px;
    animation: bounce 2s cubic-bezier(0.25, 1, 0.5, 1) infinite;
  }
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 12px;
`;

export const FlexColumns = styled.div`
  display: flex;
  gap: 40px;

  > * {
    flex: 1 1 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-flow: column nowrap;
    gap: 24px;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 18px;
`;

export const FlexRowTooltip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .subscribe-cta-container {
    margin: 14px;
  }

  .subscribe-cta-container > * {
    margin-bottom: 14px;
  }
`;

export const StyledSelect = styled(Select)`
  flex: 1;
  .ant-select-selection {
    background-color: ${({ theme }) => theme.editor.backgroundLight};
    color: ${({ theme }) => theme.editor.textLight};
  }
  margin: 5px 0px;
`;

export const Icon = styled(ReactSVG)`
  height: 14px;

  svg {
    height: 13px;
    width: 13px;

    path {
      fill: ${({ theme }) => theme.textGrey};
    }
  }
`;
